import type { PropsWithChildren } from "react";
import { createContext } from "react";
import theme from "./theme";
import type { DesignMaxThemeProps } from "./types";

export const DesignMaxTheme = createContext<DesignMaxThemeProps>(theme);

export const DesignMaxThemeProvider = ({ children }: PropsWithChildren) => {
    return <DesignMaxTheme.Provider value={theme}>{children}</DesignMaxTheme.Provider>;
};
